import { useEffect, useRef } from 'react';
import {
  LineElement,
  PointElement,
  CategoryScale, // 👈 YOU NEED THIS
  LinearScale,
  Title,
  Tooltip,
  Legend,
  Chart,
  LineController,
  ChartConfiguration,
} from 'chart.js';
import { LineChartProps } from './line-chart.props';

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
);

function LineChart({ data, options }: LineChartProps) {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chartInstance = useRef<Chart<'line'> | null>(null);

  useEffect(() => {
    const chartCanvas = chartRef.current;
    if (chartCanvas) {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      const config: ChartConfiguration<'line'> = {
        type: 'line',
        data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          ...options, // Allow overriding default options
        },
      };

      chartInstance.current = new Chart(chartCanvas, config);
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data, options]);

  return <canvas ref={chartRef} className="w-full h-full" />;
}

export default LineChart;
